module.exports = __webpack_public_path__ + "img/sy-1.68783a59.png";